import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda López',
  age: 34,
  role: 'Docente de Secundaria',
  city: 'Córdoba',
  text: 'Siempre me costaba encontrar actividades para trabajar ESI con adolescentes. Este material me resolvió las clases porque cada página ya está lista para imprimir.'
}, {
  name: 'Carolina Ruiz',
  age: 41,
  role: 'Docente de Secundaria',
  city: 'Rosario',
  text: 'Lo que más valoro es que las propuestas están pensadas realmente para secundaria. Los estudiantes participan mucho más porque los temas son actuales.'
}, {
  name: 'Luciana Gómez',
  age: 29,
  role: 'Docente de Secundaria',
  city: 'Buenos Aires',
  text: 'Los temas más difíciles eran los que más me preocupaban. Con este material pude trabajar bullying, redes sociales y salud mental con mucha más tranquilidad.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-358">
      <div className="max-w-6xl mx-auto" data-id="element-359">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#5B3FA0]" data-id="element-360">
          Lo que dicen otras docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-361">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-362">
              <div className="flex mb-2" data-id="element-363">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-364" />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-365">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-366">
                <p className="font-bold text-gray-900" data-id="element-367">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-368">{t.role}</p>
                <p className="text-sm text-gray-500" data-id="element-369">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}